module.exports = {"211324001":"大城子街道","211324002":"利州街道","211324003":"南哨街道","211324101":"南公营子镇","211324102":"山嘴子镇","211324104":"公营子镇","211324105":"白塔子镇","211324106":"中三家镇","211324107":"老爷庙镇","211324108":"六官营子镇","211324109":"平房子镇","211324110":"十二德堡镇","211324111":"羊角沟镇","211324112":"兴隆庄镇","211324113":"甘招镇","211324114":"东哨镇","211324115":"水泉镇","211324204":"尤杖子乡","211324207":"草场乡","211324210":"坤都营子乡","211324211":"大营子乡","211324214":"卧虎沟乡","211324400":"国营官大海农场","211324401":"冶金铸造工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211324.json
// module id = 546
// module chunks = 0